import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { SITE, NAV_LINKS, SERVICES, MARKETS, OFFICES } from "../data/site";
import { Logo } from "./Logo";

const Footer = () => (
    <footer className="bg-[#0D131F] text-slate-400" data-testid="footer">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 sm:py-20 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
            <div>
                <Link to="/" className="group inline-block" data-testid="footer-logo">
                    <Logo dark />
                </Link>
                <p className="mt-5 text-sm leading-relaxed" data-testid="footer-company-details">
                    ALBL Communications Private Limited. Brand, marketing &amp; sales growth partner for
                    ambitious businesses in Narmadapuram, Itarsi and surrounding Central Madhya Pradesh
                    markets.
                </p>
            </div>
            <div>
                <p className="text-xs tracking-[0.25em] uppercase font-semibold text-[#C5A059] mb-5">
                    Navigate
                </p>
                <ul className="space-y-3 text-sm">
                    {NAV_LINKS.map((l) => (
                        <li key={l.to}>
                            <Link
                                to={l.to}
                                className="hover:text-white transition-colors"
                                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            >
                                {l.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
            <div>
                <p className="text-xs tracking-[0.25em] uppercase font-semibold text-[#C5A059] mb-5">
                    Services
                </p>
                <ul className="space-y-3 text-sm">
                    {SERVICES.map((s) => (
                        <li key={s.slug}>
                            <Link
                                to={`/services#${s.slug}`}
                                className="hover:text-white transition-colors"
                                data-testid={`footer-service-${s.slug}`}
                            >
                                {s.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
            <div>
                <p className="text-xs tracking-[0.25em] uppercase font-semibold text-[#C5A059] mb-5">
                    Contact
                </p>
                <ul className="space-y-4 text-sm">
                    <li>
                        <a
                            href={SITE.phoneHref}
                            className="flex items-center gap-3 hover:text-white transition-colors"
                            data-testid="footer-phone"
                        >
                            <Phone className="h-4 w-4 text-[#C5A059]" /> {SITE.phone}
                        </a>
                    </li>
                    <li>
                        <a
                            href={SITE.whatsappPrefill}
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-center gap-3 hover:text-white transition-colors"
                            data-testid="footer-whatsapp"
                        >
                            <MessageCircle className="h-4 w-4 text-[#C5A059]" /> WhatsApp ALBL
                        </a>
                    </li>
                    <li>
                        <a
                            href={SITE.emailHref}
                            className="flex items-center gap-3 hover:text-white transition-colors break-all"
                            data-testid="footer-email"
                        >
                            <Mail className="h-4 w-4 text-[#C5A059] shrink-0" /> {SITE.email}
                        </a>
                    </li>
                    <li className="flex items-start gap-3">
                        <MapPin className="h-4 w-4 text-[#C5A059] mt-0.5 shrink-0" />
                        <span data-testid="footer-markets">
                            {MARKETS.map((m) => m.name).join(" · ")}
                        </span>
                    </li>
                    {OFFICES.map((o) => (
                        <li key={o.label} className="flex items-start gap-3">
                            <MapPin className="h-4 w-4 text-[#C5A059] mt-0.5 shrink-0" />
                            <span data-testid={`footer-office-${o.label === "Registered Office" ? "delhi" : "bhopal"}`}>
                                <span className="block text-xs uppercase tracking-wider text-slate-500">{o.label}</span>
                                {o.value}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
        <div className="border-t border-white/10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
                <p data-testid="footer-copyright">
                    © {new Date().getFullYear()} ALBL Communications Private Limited. All rights reserved.
                </p>
                <p>Brand. Marketing. Sales. Growth.</p>
            </div>
        </div>
        <div className="overflow-hidden" aria-hidden="true">
            <p className="footer-ghost font-display font-extrabold text-center select-none">ALBL</p>
        </div>
    </footer>
);

export default Footer;
